import * as Haptics from 'expo-haptics';
import { useLocalSearchParams } from 'expo-router';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';

import { authStore } from '@/stores/auth.store';
import { cashoutStore } from '@/stores/cashout.store';
import { earningsStore } from '@/stores/earnings.store';
import { CASHOUT_STATUS } from '@/types/cashout';

import { FailedView, ProcessingView, ReadyView } from '@/components/cashout/status-views';

const CashoutStatus = observer(() => {
  const { id } = useLocalSearchParams<{ id: string }>();
  const cashoutId = Number(id);
  const cashout = cashoutStore.activeCashout;
  const status = cashout?.status;

  useEffect(() => {
    if (!cashoutId) return;
    cashoutStore.startPolling(cashoutId);
    return () => cashoutStore.stopPolling();
  }, [cashoutId]);

  useEffect(() => {
    if (status === CASHOUT_STATUS.Ready) {
      void Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success);
      void earningsStore.refresh();
      void authStore.refreshMe();
    } else if (status === CASHOUT_STATUS.Failed) {
      void Haptics.notificationAsync(Haptics.NotificationFeedbackType.Error);
      void earningsStore.refresh();
      void authStore.refreshMe();
    }
  }, [status]);

  if (!cashout || status === CASHOUT_STATUS.Requested || status === CASHOUT_STATUS.Processing) {
    return <ProcessingView amountCents={cashout?.amount_cents} cashoutId={cashoutId} />;
  }

  if (status === CASHOUT_STATUS.Ready) {
    return <ReadyView amountCents={cashout.amount_cents} />;
  }

  return (
    <FailedView
      amountCents={cashout.amount_cents}
      failureReason={cashout.failure_reason}
    />
  );
});

export default CashoutStatus;
